module.exports = __webpack_public_path__ + "static/consulting-sydney-valor-1452b3d00788602a0a4ca97cf07212db.png";